<template>
	<transition name="pop-fade">
		<div
		 class="toastContainer pop-fade-container"
		 v-show="visiable"
		>{{msg}}</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			msg: "",
			visiable: false
		};
	}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
@import "~@/scss/transition.scss";
.toastContainer {
	@include pos-f($top: 66%, $left: 50%);
	transform: translateX(-50%);
	z-index: 10000000;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: px2rem(10);
	height: px2rem(40);
	line-height: px2rem(40);
	padding: 0 px2rem(20);
	color: #ffffff;
	font-size: px2rem(24);
	font-weight: 300;
	text-align: center;
	max-width: px2rem(710);
	min-width: px2rem(100);
	white-space: nowrap;
	overflow: hidden;
}
</style>
